import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { LoggedUser } from "interfaces/loggedUser";
import {
  fetchLoggedUserLocation,
  getUserLoggedInfo,
} from "services/SauceService";

export const getLoggedUserInfo = createAsyncThunk(
  "user/getLoggedUserInfo",
  async () => {
    const userInfo: any = await getUserLoggedInfo();
    return userInfo;
  }
);

export const getLoggedUserLocation = createAsyncThunk(
  "user/getLoggedUserLocation",
  async () => {
    const userLocation: any = await fetchLoggedUserLocation();
    return userLocation;
  }
);

export type UserState = {
  user: {
    loading: boolean;
    loggedUser: LoggedUser;
    location: {
      latitude: number;
      longitude: number;
    };
  };
};

export const userSlice: any = createSlice({
  name: "user",
  initialState: {
    loading: true,
    loggedUser: {},
    location: null,
  },
  reducers: {
    setBusiness: (state, action) => {
      state.loggedUser = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getLoggedUserInfo.fulfilled, (state, action) => {
      if (action.payload) {
        state.loggedUser = action.payload;
        const business = localStorage.getItem("businessId");
        if (!business && action.payload.defaultBusinessId) {
          localStorage.setItem("businessId", action.payload.defaultBusinessId);
        }
        // localStorage.setItem("businessId", action.payload.defaultBusinessId);
      }
      state.loading = false;
    });

    builder.addCase(getLoggedUserInfo.rejected, (state) => {
      state.loading = false;
    });

    builder.addCase(getLoggedUserLocation.fulfilled, (state, action) => {
      if (action.payload) {
        state.location = action.payload;
      }
    });

    builder.addCase(getLoggedUserLocation.rejected, (state) => {
      state.location = null;
    });
  },
});

export default userSlice.reducer;
